import { createFileRoute, useLocation } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";

import { SubscriptionsPage } from "./-components/SubscriptionsPage";
import { PromoSubscriptionsPage } from "./-components/PromoSubscriptionsPage";

export const Route = createFileRoute("/upgrade/")({
  component: RouteComponent,
  head: () =>
    seoHead({
      title: "Plans & Pricing | Lutely",
      description:
        "Upgrade your Lutely account to access premium features and enhance your music creation experience with our flexible subscription plans.",
      canonicalPath: "/upgrade",
    }),
});

function RouteComponent() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const promoFromSearch = searchParams.get("promo");
  if (
    promoFromSearch === "LIFETIME50" ||
    (typeof window !== "undefined" &&
      window.location.href.includes("LIFETIME50"))
  ) {
    return <PromoSubscriptionsPage />;
  }

  return <SubscriptionsPage />;
}
